import Dialog from '@/components/Dialog';
import Button from '@/components/Button';
import { RowData } from './spreadsheet';
import { useEffect } from 'react';
import { useAdminStore } from '../store/useAdmin.store';

type UserPreviewDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  users?: RowData[];
  onConfirm: () => Promise<void>;
  loading?: boolean;
};

export const UserPreviewDialog = ({ isOpen, onClose, users, onConfirm, loading }: UserPreviewDialogProps) => {
  const { page } = useAdminStore();
  const labels = page?.schoolManagement?.invitationPreview;

  useEffect(() => {
    // Reset scroll position when dialog opens
    if (isOpen) {
      setTimeout(() => {
        const content = document.querySelector('.dialog-content');
        if (content) content.scrollTop = 0;
      }, 0);
    }
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      setOpen={(open) => !open && onClose()}
      title={labels?.dialogTitle || ''}
      body={
        <>
          {users && users.length > 0 ? (
            <div className="dialog-content max-h-[60vh] overflow-y-auto">
              <table className="w-full table-auto">
                <thead>
                  <tr>
                    <th className="px-4 py-2">{labels?.userPreviewSurnameLabel || ''}</th>
                    <th className="px-4 py-2">{labels?.userPreviewForenameLabel || ''}</th>
                    <th className="px-4 py-2">{labels?.userPreviewEmailLabel || ''}</th>
                  </tr>
                </thead>
                <tbody>
                  {users?.map((user, index) => (
                    <tr key={index}>
                      <td className="border px-4 py-2">{user.surname}</td>
                      <td className="border px-4 py-2">{user.forename}</td>
                      <td className="border px-4 py-2">{user.email}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="flex items-center justify-center p-6">
              <p className="text-gray-500">{labels?.userPreviewNoStaffLabel || ''}</p>
            </div>
          )}

          <div className="mt-5 flex justify-end gap-4">
            <Button theme="outline" onClick={onClose}>
              {labels?.closeBtn || ''}
            </Button>
            <Button loading={loading} theme="solid" onClick={onConfirm}>
              {labels?.sendInvitationBtn || ''}
            </Button>
          </div>
        </>
      }
    />
  );
};
